import 'css-chunksrc/client/scenes/calendar/week/dayCreationMenu/customFields/styles.scss';export default {
  "field": "_field_8ol1l_1",
  "header": "_header_8ol1l_7",
  "label": "_label_8ol1l_14",
  "cogIconBox": "_cogIconBox_8ol1l_20",
  "cogIcon": "_cogIcon_8ol1l_20",
  "secondaryCriteria": "_secondaryCriteria_8ol1l_36"
};